import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Auth\EmailChangeVerificationController::__invoke
* @see app/Http/Controllers/Auth/EmailChangeVerificationController.php:17
* @route '//bank.finesthub.de/email-change/{verifyToken}'
*/
export const verify = (args: { verifyToken: string | number } | [verifyToken: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: verify.url(args, options),
    method: 'get',
})

verify.definition = {
    methods: ["get","head"],
    url: '//bank.finesthub.de/email-change/{verifyToken}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\EmailChangeVerificationController::__invoke
* @see app/Http/Controllers/Auth/EmailChangeVerificationController.php:17
* @route '//bank.finesthub.de/email-change/{verifyToken}'
*/
verify.url = (args: { verifyToken: string | number } | [verifyToken: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { verifyToken: args }
    }

    if (Array.isArray(args)) {
        args = {
            verifyToken: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        verifyToken: args.verifyToken,
    }

    return verify.definition.url
            .replace('{verifyToken}', parsedArgs.verifyToken.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\EmailChangeVerificationController::__invoke
* @see app/Http/Controllers/Auth/EmailChangeVerificationController.php:17
* @route '//bank.finesthub.de/email-change/{verifyToken}'
*/
verify.get = (args: { verifyToken: string | number } | [verifyToken: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: verify.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\EmailChangeVerificationController::__invoke
* @see app/Http/Controllers/Auth/EmailChangeVerificationController.php:17
* @route '//bank.finesthub.de/email-change/{verifyToken}'
*/
verify.head = (args: { verifyToken: string | number } | [verifyToken: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: verify.url(args, options),
    method: 'head',
})

const emailChange = {
    verify: Object.assign(verify, verify),
}

export default emailChange